import { render, staticRenderFns } from "./IndividualRootView.vue?vue&type=template&id=d6471f20"
import script from "./IndividualRootView.vue?vue&type=script&lang=js"
export * from "./IndividualRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports